import { createApp } from 'vue';
import App from './App.vue';
import { createPinia } from 'pinia';
import { srSymbol, speechrecognition } from '@/plugins/speechrecognition';
import router from './router';
import development from '@/config/development.json';
import production from '@/config/production.json';
import VueTippy from 'vue-tippy';
import 'tippy.js/dist/tippy.css'; // optional for styling
import emitter from '@/plugins/emitter';

import './sass/flag-icons.scss';
import './css/reset.css';
import './css/style.css';

if (import.meta.NODE_ENV === 'production') {
  createApp.config = Object.freeze(production);
} else {
  createApp.config = Object.freeze(development);
}

const app = createApp(App);

const pinia = createPinia();
app.provide('emitter', emitter);
app.provide(srSymbol, speechrecognition);
app.use(pinia);
app.use(router);
app.use(VueTippy);
app.mount('#app');
